<template>
  <div class="show-form-cars">
    <table class="table">
      <tbody>
        <tr>
          <td class="label-col">Марка</td>
          <td>{{ car.brand }}</td>
        </tr>
        <tr>
          <td>Модель</td>
          <td>{{ car.model }}</td>
        </tr>
        <tr>
          <td>Рег. номер</td>
          <td>{{ car.registration_plate }}</td>
        </tr>
        <tr>
          <td>Год выпуска</td>
          <td>{{ car.manufacturing_year }}</td>
        </tr>
        <tr>
          <td>Код радио</td>
          <td>{{ car.radio_code }}</td>
        </tr>
        <tr>
          <td>Пробег</td>
          <td>{{ actualOdometer }}</td>
        </tr>
        <tr>
          <td>Устройство геопозиционирования</td>
          <td>{{ car.trackingDevice ? car.trackingDevice.name : null }}</td>
        </tr>
        <tr>
          <td>IMEI</td>
          <td>{{ car.trackingDevice ? car.trackingDevice.imei : null }}</td>
        </tr>
        <tr>
          <td>Статус</td>
          <td class="col-state"><State :car="car" /></td>
        </tr>
      </tbody>
    </table>
    <hr class="mb-4" />
  </div>
</template>

<script>
import odometerCorrectionApi from '@/api/odometercorrection'

export default {
  name: 'CarShowForm',
  props: ['id', 'car'],
  data () {
    return {
      actualOdometer: 0
    }
  },
  watch: {
    car: {
      handler () {
        odometerCorrectionApi.getActualOdometer({ id: this.car.id })
          .then(odometer => {
            this.actualOdometer = odometer
          })
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
  .show-form-cars {
    margin-top: 4rem;
  }
  .label-col {
    width: 25%;
  }
  .col-state {
    padding: 0 !important;
    vertical-align: middle;
  }
</style>
